import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";

export interface ReloadableCardGlobalConfig {
  id: string;
  sku: string;
  name: string;
  product_type: string;
  currency_code: string;
  brand: string;
  provider: string;
}

export interface ReloadableCardsGlobalsResponse {
  size: number;
  links: any;
  data: ReloadableCardGlobalConfig[];
}

@Injectable({
  providedIn: "root",
})
export class ReloadableCardsGlobalsService {
  private readonly CARDS_URL = `${environment.orders_api.base_url}/reloadable-cards/cards`;

  constructor(private http: HttpClient) {}

  getConfigurableReloadableCards(): Observable<ReloadableCardGlobalConfig[]> {
    return this.http
      .get<ReloadableCardsGlobalsResponse>(this.CARDS_URL)
      .pipe(map((response) => response.data));
  }
}
